import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { device } from '../../../utils/helpers'

const CardBottom = styled.div`
  display: flex;
  background-color: ${props => props.selected ? props.theme.color.hoverPrimary : '#4d4d4d'};
  justify-content: center;
  width: 100%;
  padding: 10px 0;
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  font-size: 18px;
  color: #fff;

  @media ${device.tablet} {
    ${'' /* padding: 16px 0;
    font-size: 24px; */}
    padding: 0.8333333333333334vw 0;
    font-size: 1.25vw;
  }
`

const OuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 160px;
  justify-content: space-between;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  border: 5px solid ${props => props.selected ? props.theme.color.hoverPrimary : 'transparent'};
  outline: none;

  @media ${device.tablet} {
  ${''/* width: 260px; */}
    width: 13.541666666666668vw;
  }

  &:hover {
    border: 5px solid ${props => props.theme.color.hoverPrimary};
  }

  &:hover ${CardBottom} {
    background-color: ${props => props.theme.color.hoverPrimary};
  }
`

const InnerWrapper = styled.div`
  padding: 0 9px;
  background-color: #F3F3F3;

  @media ${device.tablet} {
    padding: 0 0.9375vw;
  }
`

const Image = styled.img`
  width: 100%;
  height: 88px;
  padding-top: 9px;

  @media ${device.tablet} {
    ${'' /* height: 168px;
    padding-top: 18px; */}
    height: 7.8vw;
    padding-top: 0.9375vw;
  }
`

const CardFooter = styled.div`
  background-color: #F3F3F3;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-bottom: 10px;
  min-height: 95px;

  @media ${device.tablet} {
    ${'' /* padding-top: 18px;
    padding-bottom: 16px; */}
    padding-top: 0.9375vw;
    padding-bottom: 0.8333333333333334vw;
    height: 5.833333333333334vw;
    min-height: inherit;
  }
`

const FooterTitle = styled.h3`
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  color: #4d4d4d;
  padding-bottom: 7px;
  width: 100%;
  line-height: 1.25em;
  width: 95%;
  font-size: 16px;

  @media ${device.tablet} {
    font-size: 1.25vw;
    padding-bottom: 0.9375vw;
  }

`

const Price = styled.p`
  font-family: 'BarlowExtraBold';
  color: #fca317;
  padding-bottom: 2px;
  width: 60%;
  font-size: 18px;

  @media ${device.tablet} {
    font-size: 1.25vw;
  }
`

const CustomizeCard = ({ title, price, image, selected, ...props }) => {
  return (
    <OuterWrapper selected={selected} {...props}>
      <InnerWrapper>
        <Image src={image} />
      </InnerWrapper>
      <CardFooter>
        <FooterTitle>{title}</FooterTitle>
        <Price>{price}</Price>
      </CardFooter>
      <CardBottom selected={selected}>AGGIUNGI</CardBottom>
    </OuterWrapper>
  )
}

CustomizeCard.propTypes = {
  /**
   * Title of the Card
   */
  title: PropTypes.string,

  /**
   * Price at the footer of the Card
   */
  price: PropTypes.string.isRequired,

  /**
   * Image of the Card
   */
  image: PropTypes.string.isRequired
}

export default CustomizeCard



// WEBPACK FOOTER //
// ./src/components/Calculator/Card/CustomizeCard.js